import type { ColorPickerProps, GetProp } from 'antd';

export type Color = Extract<GetProp<ColorPickerProps, 'value'>, string | { cleared: any }>;

export const formatColorToHexString = (color: Color) => {
  return typeof color === 'string' ? color : color?.toHexString();
};
